<!-- Toolbar Header -->
<mat-toolbar class="event-toolbar" color="primary">
  <div class="toolbar-content">
    <h2 class="title">
      Acción realizada ::
      <strong>{{ this.data.esNuevo ? 'Crear' : this.data.esEliminar ? 'Eliminar' : this.data.esVista ? 'Ver' : 'Modificar' }}</strong>
    </h2>

    <div class="toolbar-actions">
      <button mat-icon-button *ngIf="this.data.esVista && data.item?.esEditable" (click)="modificarEvento()"
        matTooltip="Editar evento">
        <mat-icon>edit</mat-icon>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="actionsMenu" matTooltip="Más acciones" *ngIf="this.data.esVista">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #actionsMenu="matMenu">
        <button mat-menu-item (click)="cancelEvent()"
          *ngIf="data.item?.estadoEventoAgenda?.descripcion !== 'Cancelado'">
          <mat-icon>cancel</mat-icon>
          <span>Cancelar evento</span>
        </button>
        <button mat-menu-item (click)="duplicateEvent()">
          <mat-icon>content_copy</mat-icon>
          <span>Duplicar</span>
        </button>
        <button mat-menu-item (click)="exportEvent()">
          <mat-icon>download</mat-icon>
          <span>Exportar</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="eliminarEvento()" class="danger-item">
          <mat-icon>delete</mat-icon>
          <span>Eliminar</span>
        </button>
      </mat-menu>

      <button mat-icon-button [mat-dialog-close]="true" matTooltip="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>



<ngx-spinner [zIndex]="100" name="spEventoDialogCalendar" bdColor="rgba(255,255,255,0.8)" size="default"
  bdColor="rgba(0, 0, 0, 0.4)" color="var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>


<!-- Dialog Content -->
<mat-dialog-content class="dialog-content-container">

  <!-- Delete Confirmation -->
  <div class="delete-confirmation-container" *ngIf="this.data.esEliminar">
    <mat-card class="delete-card">
      <mat-card-header>
        <div mat-card-avatar class="delete-avatar">
          <mat-icon>warning</mat-icon>
        </div>
        <mat-card-title>Confirmar eliminación</mat-card-title>
        <mat-card-subtitle>Esta acción no se puede deshacer</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="event-preview">
          <h3>{{ data.item?.titulo }}</h3>
          <div class="event-meta">
            <mat-chip-listbox>
              <mat-chip>
                <mat-icon>schedule</mat-icon>
                {{ data.item?.fechaInicio | date: 'mediumDate' }}
              </mat-chip>
              <mat-chip *ngIf="data.item?.lugar">
                <mat-icon>place</mat-icon>
                {{ data.item?.lugar }}
              </mat-chip>
            </mat-chip-listbox>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Main Content with Tabs -->
  <div class="main-content" *ngIf="!this.data.esEliminar">

    <!-- Tabs for Form/View -->
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="event-tabs" animationDuration="300ms"
      [dynamicHeight]="true">

     <!-- Basic Information Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">info</mat-icon>
          <span>Información</span>
          <mat-icon class="error-badge"
                   *ngIf="hasErrorsInBasicInfo()"
                   matBadge="!"
                   matBadgeColor="warn"
                   matBadgeSize="small">
          </mat-icon>
        </ng-template>

        <div class="tab-content" *ngIf="!this.data.esVista">
          <form [formGroup]="form">

            <!-- Title -->
            <mat-card class="info-card">
              <mat-card-content>
                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Título del evento</mat-label>
                    <input matInput
                           formControlName="Titulo"
                           placeholder="Nombre descriptivo del evento">
                    <mat-icon matSuffix>title</mat-icon>
                    <mat-hint>Máximo 255 caracteres</mat-hint>
                    <mat-error *ngIf="form.get('Titulo')?.hasError('required')">
                      El título es requerido
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Type and State -->
                <div class="form-grid">
                  <mat-form-field appearance="outline">
                    <mat-label>Tipo de evento</mat-label>
                    <mat-select formControlName="IdTipoEvento">
                      <mat-option *ngFor="let tipo of listaTiposEvento;trackBy: trackByFn" [value]="tipo.id">
                        {{ tipo.descripcion }}
                      </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>category</mat-icon>
                    <mat-error *ngIf="form.get('IdTipoEvento')?.hasError('required')">
                      Seleccione un tipo
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Estado</mat-label>
                    <mat-select formControlName="IdEstadoEvento">
                      <mat-option *ngFor="let estado of estadosEventoAgenda;trackBy: trackByFn" [value]="estado.id">
                        <mat-icon>{{ getStatusIcon(estado.descripcion) }}</mat-icon>
                        {{ estado.descripcion }}
                      </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>flag</mat-icon>
                    <mat-error *ngIf="form.get('IdEstadoEvento')?.hasError('required')">
                      Seleccione un estado
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Prioridad</mat-label>
                    <mat-select formControlName="Prioridad">
                      <mat-option [value]="1">
                        <mat-icon class="priority-low">flag</mat-icon>
                        Baja
                      </mat-option>
                      <mat-option [value]="2">
                        <mat-icon class="priority-medium">flag</mat-icon>
                        Media
                      </mat-option>
                      <mat-option [value]="3">
                        <mat-icon class="priority-high">flag</mat-icon>
                        Alta
                      </mat-option>
                      <mat-option [value]="4">
                        <mat-icon class="priority-critical">flag</mat-icon>
                        Crítica
                      </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>priority_high</mat-icon>
                  </mat-form-field>
                </div>

                <!-- Description -->
                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Descripción</mat-label>
                    <textarea matInput
                              formControlName="Descripcion"
                              rows="3"
                              placeholder="Descripción detallada del evento">
                    </textarea>
                    <mat-icon matSuffix>description</mat-icon>
                    <mat-hint>Información principal del evento</mat-hint>
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </form>
        </div>

        <!-- View Mode for Basic Info -->
        <div class="tab-content view-mode" *ngIf="this.data.esVista">
          <mat-card >
            <mat-card-header>
              <!-- <app-avatar-iniciales [nombre]='data.item?.asignadoA?.nombre' [apellido]='audiencia.asignadoA?.apellido'
              [activo]='data.item?.asignadoA?.activo'></app-avatar-iniciales> -->

              <mat-card-title>{{ data.item?.titulo }}</mat-card-title>
              <mat-card-subtitle>{{ data.item?.tipoEventoAgenda?.descripcion }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <mat-list>
                <mat-list-item>
                  <mat-icon matListItemIcon>flag</mat-icon>
                  <div matListItemTitle>Estado</div>
                  <div matListItemLine>{{ data.item?.estadoEventoAgenda?.descripcion }}</div>
                </mat-list-item>
                <mat-list-item *ngIf="data.item?.prioridad">
                  <mat-icon matListItemIcon>priority_high</mat-icon>
                  <div matListItemTitle>Prioridad</div>
                  <div matListItemLine>{{ getPriorityText(data.item?.prioridad) }}</div>
                </mat-list-item>
                <mat-list-item *ngIf="data.item?.descripcion">
                  <mat-icon matListItemIcon>description</mat-icon>
                  <div matListItemTitle>Descripción</div>
                  <div matListItemLine>{{ data.item?.descripcion }}</div>
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

      <!-- Schedule Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">schedule</mat-icon>
          <span>Programación</span>
          <mat-icon class="error-badge" *ngIf="hasErrorsInSchedule()" matBadge="!" matBadgeColor="warn"
            matBadgeSize="small">
          </mat-icon>
        </ng-template>

        <div class="tab-content" *ngIf="!this.data.esVista">
          <form [formGroup]="form">
            <mat-card class="schedule-card">
              <mat-card-content>



                <!-- Date Fields -->
                <div class="date-grid">
                  <mat-form-field appearance="outline">
                    <mat-label>Fecha de inicio</mat-label>
                    <input matInput [matDatepicker]="startPicker" formControlName="FechaInicio" readonly>
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                    <mat-error *ngIf="form.get('FechaInicio')?.hasError('required')">
                      Fecha requerida
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" *ngIf="form.get('EsTodoElDia')?.value">
                    <mat-label>Fecha de fin</mat-label>
                    <input matInput [matDatepicker]="endPicker" formControlName="FechaFin" readonly>
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                    <mat-error *ngIf="form.get('FechaFin')?.hasError('required')">
                      Fecha requerida
                    </mat-error>
                  </mat-form-field>

                  <!-- All Day Toggle -->
                <div class="toggle-section">
                  <mat-slide-toggle formControlName="EsTodoElDia" (change)="onToggleTodoElDia()" color="primary"
                    class="all-day-toggle">
                    Todo el día
                  </mat-slide-toggle>
                </div>
                </div>

                <!-- Time Fields -->
                <div class="time-grid" *ngIf="!form.get('EsTodoElDia')?.value">
                  <mat-form-field appearance="outline">
                    <mat-label>Hora de inicio</mat-label>
                    <input matInput type="time" formControlName="HoraInicio">
                    <mat-icon matSuffix>schedule</mat-icon>
                    <mat-error *ngIf="form.get('HoraInicio')?.hasError('required')">
                      Hora requerida
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Hora de fin</mat-label>
                    <input matInput type="time" formControlName="HoraFin">
                    <mat-icon matSuffix>schedule</mat-icon>
                    <mat-error *ngIf="form.get('HoraFin')?.hasError('required')">
                      Hora requerida
                    </mat-error>
                  </mat-form-field>

                  <div class="duration-info" *ngIf="calculateDuration() !== 'No definida'">
                    <mat-icon>timer</mat-icon>
                    <span>Duración: {{ calculateDuration() }}</span>
                  </div>
                </div>

                <!-- Timezone -->
                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Zona horaria</mat-label>
                    <mat-select formControlName="ZonaHoraria">
                      <mat-option *ngFor="let tz of timeZoneList;trackBy: trackByFn" [value]="tz.value">
                        {{ tz.label }}
                      </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>public</mat-icon>
                  </mat-form-field>
                </div>

                <!-- Repeat Button -->
                <!-- <div class="repeat-section">
                  <button mat-stroked-button
                          type="button"
                          (click)="openRepeatDialog()"
                          color="accent">
                    <mat-icon>autorenew</mat-icon>
                    {{ hasRepetition() ? 'Modificar repetición' : 'Hacer periódico' }}
                  </button>
                </div> -->
              </mat-card-content>
            </mat-card>
          </form>
        </div>

        <!-- View Mode for Schedule -->
        <div class="tab-content view-mode" *ngIf="this.data.esVista">
          <mat-card>
            <mat-card-header>
              <mat-card-title>
                Programación
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-list>
                <mat-list-item>
                  <mat-icon matListItemIcon>calendar_today</mat-icon>
                  <div matListItemTitle>Fecha</div>
                  <div matListItemLine>
                    {{ data.item?.fechaInicio | date: 'fullDate' }}
                    <span *ngIf="data.item?.fechaFin && data.item.fechaInicio !== data.item.fechaFin">
                      hasta {{ data.item?.fechaFin | date: 'fullDate' }}
                    </span>
                  </div>
                </mat-list-item>
                <mat-list-item *ngIf="!data.item?.esTodoElDia">
                  <mat-icon matListItemIcon>access_time</mat-icon>
                  <div matListItemTitle>Horario</div>
                  <div matListItemLine>{{ data.item?.horaInicio }} - {{ data.item?.horaFin }}</div>
                </mat-list-item>
                <mat-list-item *ngIf="data.item?.esTodoElDia">
                  <mat-icon matListItemIcon>all_day</mat-icon>
                  <div matListItemTitle>Duración</div>
                  <div matListItemLine>Todo el día</div>
                </mat-list-item>
                <mat-list-item *ngIf="data.item?.zonaHoraria">
                  <mat-icon matListItemIcon>public</mat-icon>
                  <div matListItemTitle>Zona horaria</div>
                  <div matListItemLine>{{ data.item?.zonaHoraria }}</div>
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

      <!-- Location Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">place</mat-icon>
          <span>Ubicación</span>
        </ng-template>

        <div class="tab-content" *ngIf="!this.data.esVista">
          <form [formGroup]="form">
            <mat-card class="location-card">
              <mat-card-content>
                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Lugar</mat-label>
                    <input matInput formControlName="Lugar" placeholder="Dirección, sala, oficina, etc.">
                    <mat-icon matSuffix>location_on</mat-icon>
                    <mat-hint>Ubicación física o virtual del evento</mat-hint>
                  </mat-form-field>
                </div>

                <div class="modality-section">
                  <div class="modality-toggles">
                    <mat-slide-toggle formControlName="EsEventoPresencial" color="primary">
                      Evento presencial
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="EsEventoVirtual" color="accent">
                      Evento virtual
                    </mat-slide-toggle>
                  </div>
                </div>

                <div class="form-row" *ngIf="form.get('EsEventoVirtual')?.value">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>URL de la reunión</mat-label>
                    <input matInput formControlName="Url" placeholder="https://...">
                    <mat-icon matSuffix>link</mat-icon>
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </form>
        </div>

        <!-- View Mode for Location -->
        <div class="tab-content view-mode" *ngIf="this.data.esVista">
          <mat-card>
            <mat-card-header>
              <mat-card-title>
                Ubicación
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-list>
                <mat-list-item *ngIf="data.item?.lugar">
                  <mat-icon matListItemIcon>location_on</mat-icon>
                  <div matListItemTitle>Lugar</div>
                  <div matListItemLine>{{ data.item?.lugar }}</div>
                </mat-list-item>
                <mat-list-item *ngIf="data.item?.esEventoPresencial">
                  <mat-icon matListItemIcon>person</mat-icon>
                  <div matListItemTitle>Modalidad</div>
                  <div matListItemLine>Evento presencial</div>
                </mat-list-item>
                <mat-list-item *ngIf="data.item?.url">
                  <mat-icon matListItemIcon>videocam</mat-icon>
                  <div matListItemTitle>Reunión virtual</div>
                  <div matListItemLine>
                    <a [href]="data.item?.url" target="_blank" class="url-link">
                      {{ data.item?.url }}
                    </a>
                  </div>
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

      <!-- Notifications Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">notifications</mat-icon>
          <span>Notificaciones</span>
        </ng-template>

        <div class="tab-content" *ngIf="!this.data.esVista">
          <form [formGroup]="form">
            <mat-card class="notifications-card">
              <mat-card-content>
                <div class="form-grid">
                  <mat-form-field appearance="outline">
                    <mat-label>Recordatorio</mat-label>
                    <mat-select formControlName="Recordatorio">
                      <mat-option *ngFor="let reminder of reminderOptions;trackBy: trackByFn" [value]="reminder.value">
                        <mat-icon>alarm</mat-icon>
                        {{ reminder.label }}
                      </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>alarm</mat-icon>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Minutos de aviso</mat-label>
                    <input matInput type="number" formControlName="AvisoNMinutosAntes" min="0" max="43200">
                    <mat-icon matSuffix>schedule</mat-icon>
                    <mat-hint>0 = sin aviso</mat-hint>
                  </mat-form-field>
                </div>

                <!-- <div class="notification-options">
                  <mat-slide-toggle
                    formControlName="EsAvisoAPartes"
                    color="primary">
                    Notificar a las partes involucradas
                  </mat-slide-toggle>
                </div> -->
              </mat-card-content>
            </mat-card>
          </form>
        </div>

        <!-- View Mode for Notifications -->
        <div class="tab-content view-mode" *ngIf="this.data.esVista">
          <mat-card>
            <mat-card-header>
              <mat-card-title>
                Notificaciones
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-list>
                <mat-list-item *ngIf="data.item?.avisoNMinutosAntes && data.item.avisoNMinutosAntes > 0">
                  <mat-icon matListItemIcon>alarm</mat-icon>
                  <div matListItemTitle>Recordatorio</div>
                  <div matListItemLine>{{ data.item?.avisoNMinutosAntes }} minutos antes</div>
                </mat-list-item>
                <mat-list-item *ngIf="data.item?.esAvisoAPartes">
                  <mat-icon matListItemIcon>group</mat-icon>
                  <div matListItemTitle>Notificaciones</div>
                  <div matListItemLine>Se notificará a las partes involucradas</div>
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

      <!-- Notes Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">notes</mat-icon>
          <span>Observaciones</span>
        </ng-template>

        <div class="tab-content" *ngIf="!this.data.esVista">
          <form [formGroup]="form">
            <mat-card class="notes-card">
              <mat-card-content>
                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Observaciones</mat-label>
                    <textarea matInput formControlName="Observaciones" rows="6"
                      placeholder="Notas adicionales, comentarios internos, instrucciones especiales, etc.">
                    </textarea>
                    <mat-icon matSuffix>notes</mat-icon>
                    <mat-hint>{{ form.get('Observaciones')?.value?.length || 0 }}/1000 caracteres</mat-hint>
                    <mat-error *ngIf="form.get('Observaciones')?.hasError('maxlength')">
                      Máximo 1000 caracteres
                    </mat-error>
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </form>
        </div>

        <!-- View Mode for Notes -->
        <div class="tab-content view-mode" *ngIf="this.data.esVista">
          <mat-card>
            <mat-card-header>
              <mat-card-title>
                Observaciones
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="notes-display">
                <p *ngIf="data.item?.observaciones" class="note-text">
                  {{ data.item?.observaciones }}
                </p>
                <p *ngIf="!data.item?.observaciones" class="no-notes">
                  No hay observaciones para este evento.
                </p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</mat-dialog-content>

<!-- Botones de acción -->
<mat-dialog-actions align="end">

  <!-- Botones para eliminar -->
  <ng-container *ngIf="this.data.esEliminar">
    <app-button-cancel-dialog></app-button-cancel-dialog>
    <app-button-delete (click)="eliminar()"></app-button-delete>
  </ng-container>

  <!-- Botones para crear -->
  <ng-container *ngIf="this.data.esNuevo">
    <app-button-cancel-dialog></app-button-cancel-dialog>
    <app-button-add [disabled]="!isFormValid" (click)="create()">
    </app-button-add>
  </ng-container>

  <!-- Botones para editar -->
  <ng-container *ngIf="data.esEditar">
    <app-button-cancel-dialog></app-button-cancel-dialog>
    <app-button-save (click)="modificar()" [disabled]="!isFormValid"></app-button-save>
  </ng-container>

  <!-- Botones para vista -->
  <ng-container *ngIf="this.data.esVista && !data.esEditar">
    <app-button-close></app-button-close>
  </ng-container>

</mat-dialog-actions>
